import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import analyticsFiltersApi from "../api/analytics/analyticsFiltersApi";
import { PointInTimeFloor } from "../helpers/analytics/pointInTimeFilterHelpers";
import ErrorLogger from "../logging/ErrorLogger";

/** Floor lookup failed - treat as no history so we never offer an unhonourable date. */
const NO_HISTORY: PointInTimeFloor = {
  earliestSelectableDate: null,
  enabled: false,
};

/**
 * Show past data picker floor for the current client (ADR-0006).
 * Pass `enabled: false` on pages that cannot use point-in-time at all so the
 * lookup is skipped entirely.
 */
export function useAnalyticsPointInTimeFloor(enabled: boolean) {
  const auth = useAuth();
  const accessToken = auth.user?.access_token;
  const [floor, setFloor] = useState<PointInTimeFloor | null>(null);
  const [isLoading, setIsLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setFloor(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    new analyticsFiltersApi(accessToken)
      .getPointInTimeFloor()
      .then((data) => {
        if (cancelled) return;
        setFloor(data ?? NO_HISTORY);
        setIsLoading(false);
      })
      .catch((error) => {
        if (cancelled) return;
        ErrorLogger.log("load point-in-time floor: " + error);
        setFloor(NO_HISTORY);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, accessToken]);

  return { floor, isLoading };
}

export default useAnalyticsPointInTimeFloor;
